import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs';

@Injectable()
export class Interceptor implements HttpInterceptor {
  constructor() {}
  // Adds cache control headers to prevent caching issues
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Add cache control headers to prevent caching issues
    const headers = request.headers
      .set('Cache-Control', 'no-cache')
      .set('Pragma', 'no-cache')
      .set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT');
    const httpRequest = request.clone({ headers });

    return next.handle(httpRequest).pipe(tap({
      next: (event: HttpEvent<unknown>) => {
        if (event instanceof HttpResponse) {
          // do stuff with response
        }
      },
      error: (err: HttpErrorResponse) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 503) {
            console.log('HTTP Interceptor: Maintenance mode detected (503)');
          }
          else if (err.status === 401) {
            console.log('HTTP Interceptor: Unauthorized request (401) - will be handled by JWT interceptor');
          }
        }
      }
    }));
  }
}

